/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {MDXWrapper} from 'lib/mdx';
import Image from 'next/image';
import ImageTabs from 'components/image-tabs';
import toolbar from '../public/how-to/google-meet/1-toolbar.png';
import recordMeeting from '../public/how-to/google-meet/2-record.png';
import startRecording from '../public/how-to/google-meet/3-start-recording.png';
import meetRecordings from '../public/how-to/google-meet/4-meet-recordings.png';
export const metadata = {
  title: 'Transcribe a Google Meet Recording',
  description: 'Transcribe any Google Meet recording by following this easy step-by-step guide to using the TranscribeKit speech-to-text add-on for Google Drive'
};
const MDXLayout = function Layout({children}) {
  return _jsx(MDXWrapper, {
    metadata: metadata,
    children: children
  });
};
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h1: "h1",
      p: "p",
      a: "a",
      em: "em",
      h2: "h2",
      strong: "strong"
    }, props.components);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h1, {
        children: "How to Transcribe a Google Meet Recording"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.a, {
          href: "https://meet.google.com/",
          target: "_blank",
          rel: "nofollow noopener noreferrer",
          children: _jsx(_components.em, {
            children: "Google Meet"
          })
        }), " allows you to record your meetings which you can then transcribe to text using our ", _jsx(_components.em, {
          children: "Google Drive"
        }), " add-on. Follow these steps to record and transcribe your next meeting."]
      }), "\n", _jsxs(_components.h2, {
        children: ["1. Record your ", _jsx(_components.em, {
          children: "Google Meet"
        }), " meeting"]
      }), "\n", _jsx(_components.p, {
        children: "Start your meeting and click on the button with three dots."
      }), "\n", _jsx("div", {
        className: "flex justify-center",
        children: _jsx("div", {
          className: "flex w-max",
          children: _jsx(Image, {
            src: toolbar,
            alt: "Google Meet toolbar",
            quality: 100,
            placeholder: "blur",
            priority: true
          })
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Next, click on ", _jsx(_components.strong, {
          children: "Record meeting"
        }), " and in the panel that pops up click ", _jsx(_components.strong, {
          children: "Start recording"
        }), "."]
      }), "\n", _jsx("div", {
        className: "flex justify-center",
        children: _jsx(ImageTabs, {
          images: [{
            image: recordMeeting,
            caption: 'Record meeting'
          }, {
            image: startRecording,
            caption: 'Start recording'
          }]
        })
      }), "\n", _jsxs(_components.p, {
        children: ["If you have any issues then ", _jsxs(_components.a, {
          href: "https://support.google.com/meet/answer/9308681",
          target: "_blank",
          rel: "nofollow noopener noreferrer",
          children: ["click here for ", _jsx(_components.em, {
            children: "Google's"
          }), " full recording guide"]
        })]
      }), "\n", _jsxs(_components.h2, {
        children: ["2. Find the recording in ", _jsx(_components.em, {
          children: "Google Drive"
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["Once your meeting has finished, wait a few minutes and you'll receive an email telling you that the recording has been uploaded to ", _jsx(_components.em, {
          children: "Google Drive"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["Click ", _jsx(_components.a, {
          href: "https://drive.google.com",
          target: "_blank",
          rel: "nofollow noopener noreferrer",
          children: "here"
        }), " to open ", _jsx(_components.em, {
          children: "Google Drive"
        }), " in a new tab. From there double-click on the ", _jsx(_components.strong, {
          children: "Meet Recordings"
        }), " folder and you should see all your recordings. Double-click on a recording to play it and check that it's the correct one."]
      }), "\n", _jsx("div", {
        className: "flex justify-center",
        children: _jsx("div", {
          className: "flex border w-max",
          children: _jsx(Image, {
            src: meetRecordings,
            alt: "Meet recordings folder",
            quality: 100,
            placeholder: "blur",
            priority: true
          })
        })
      }), "\n", _jsx(_components.h2, {
        children: "3. Request a transcription"
      }), "\n", _jsxs(_components.p, {
        children: ["Now that you have the recording in ", _jsx(_components.em, {
          children: "Google Drive"
        }), " you can transcribe it using the ", _jsx(_components.em, {
          children: "TranscribeKit"
        }), " add-on. ", _jsx(_components.a, {
          href: "/how-to-transcribe",
          children: "Click here for the full step-by-step guide"
        })]
      }), "\n", _jsx(_components.h2, {
        children: "Related Articles"
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "/how-to-transcribe",
          children: "How to Transcribe Audio or Video to Text"
        })
      })]
    });
  }
}
export default MDXContent;
